import React from 'react';
import { Typography, Card, Button, Image } from 'antd';
import { Link } from 'react-router-dom';
import styles from './login.module.scss';

const { Title } = Typography;

const SuccessfulPasswordChange = () => {
  return (
    <div className={styles.login}>
      <div className={styles.login__left}>
        <div className={styles.login__logo}>
          <Link to="/">
            <img src="/logo.svg" alt="Logo" height={30} width={100} />
          </Link>
        </div>
        <div className={styles.login__formCard}>
          <Card className={styles.login__card}>
            <Image
              src={'/assets/icons/check.svg'}
              alt="Uspešno"
              width={48}
              height={48}
            />
            <Title className={styles.login__title} level={1}>
              Uspesno ste promenili sifru!
            </Title>
            <Button type="primary" href="/">
              Nastavi
            </Button>
          </Card>
        </div>
      </div>
      <div className={styles.login__right}></div>
    </div>
  );
};

export default SuccessfulPasswordChange;
